// Extracted verbatim (programmatically, not hand-transcribed) from
// SCERS_Retirement_Calculator_v6_0_7.html on 2026-09-22.
// Do not hand-edit these values. If the source calculator is revised, re-run the
// extraction script against the new version and regenerate this file.

// Federal limit on survivor continuance for a beneficiary who is not the
// member's spouse (IRS "QJSA" / minimum-distribution incidental-benefit table):
// key = whole years the member is older than the beneficiary, value = max
// continuance %. Gaps of 10 years or less allow 100%; gaps over 44 use 44.
export const NONSPOUSE_SURVIVOR_LIMIT_PCT = {
  "10": 100,
  "11": 96,
  "12": 93,
  "13": 90,
  "14": 87,
  "15": 84,
  "16": 82,
  "17": 79,
  "18": 77,
  "19": 75,
  "20": 73,
  "21": 72,
  "22": 70,
  "23": 68,
  "24": 67,
  "25": 66,
  "26": 64,
  "27": 63,
  "28": 62,
  "29": 61,
  "30": 60,
  "31": 59,
  "32": 59,
  "33": 58,
  "34": 57,
  "35": 56,
  "36": 56,
  "37": 55,
  "38": 55,
  "39": 54,
  "40": 54,
  "41": 53,
  "42": 53,
  "43": 53,
  "44": 52
} as const;
